import {IAccomodation} from '@/model/Accomodation';

export interface IHasAccomodations {
    getAccomodations(): IAccomodation[]
    getAccomodationsMap(): Map<string, IAccomodation>
    addAccomodation(accomodation: IAccomodation): void
    removeAccomodation(accomodation: IAccomodation): void
}

function hasAccomodations<TBase extends Constructor>(Base: TBase) {
    
    class Bob extends Base implements IHasAccomodations {
        private accomodations: IAccomodation[] = []
        private accomodationsMap: Map<string, IAccomodation> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }

        public getAccomodations(): IAccomodation[] {
            return this.accomodations
        }
        public getAccomodationsMap(): Map<string, IAccomodation> {
            return this.accomodationsMap
        }
    
        public addAccomodation(accomodation: IAccomodation): void {
            if (this.accomodationsMap.has(accomodation.getIdFull())) return
            this.accomodations.push(accomodation)
            this.accomodationsMap.set(accomodation.getIdFull(), accomodation)
        }
        public removeAccomodation(accomodation: IAccomodation): void {
            if (!this.accomodationsMap.has(accomodation.getIdFull())) return
            this.accomodations = this.accomodations.filter((_=>_.getIdFull() !== accomodation.getIdFull()))
            this.accomodationsMap.delete(accomodation.getIdFull())
        }
    }
    return Bob
}

export default hasAccomodations